<template>
  <div>
    <el-row>
      <el-col :span="6">
        <el-tree :data="areaList.result.areaList" :props="defaultProps" accordion @node-click="handleNodeClick" ></el-tree>
        <el-button style="width: 100%; margin-top: 10px;" type="primary" size="small" icon="el-icon-circle-plus-outline"
          @click="openAddQuDialog"></el-button>
      </el-col>
      <el-col :span="17" offset="1">
        <el-card>
          <div slot="header" class="clearfix">
            <span>区域信息</span>
          </div>
          <el-form label-position="left" inline class="demo-table-expand" title="区域信息">
            <el-form-item label="区域名称">
              <span>{{chosenLabel}}</span>
            </el-form-item>
            <el-form-item label="区域Id">
              <span>{{chosenAreaId}}</span>
            </el-form-item>
            <br>
            <el-form-item label="负责人">
              <span>{{chosenUser}}</span>
            </el-form-item>
            <el-form-item style="margin-top: 10px;">
              <el-button @click="addAreaDialogVisible" type="primary" size="medium">添加子区域</el-button>
              <el-button @click="UpdateAreaDialogVisible" type="default" size="medium">修改区域</el-button>
              <el-button @click="deleteArea" type="danger" size="medium">删除区域</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="addAreaVisible" title="添加子区域" @close="closeAddArea" v-if="addAreaVisible">
      <el-form label-width="100px">
        <el-form-item label="子区域名称">
          <el-input v-model="AddArea.params.areaName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddArea">取 消</el-button>
        <el-button type="primary" @click="addArea">确定添加</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="updateAreaVisible" title="修改区域" @close="closeUpdateArea" v-if="updateAreaVisible">
      <el-form label-width="100px">
        <el-form-item label="当前区域名称">
          <el-tag>{{chosenLabel}}</el-tag>
        </el-form-item>
        <el-form-item label="新区域名称">
          <el-input v-model="UpdateArea.params.newAreaName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateArea">取 消</el-button>
        <el-button type="primary" @click="updateArea">确定修改</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="addQuDialogVisible" title="添加区域" @close="closeAddQuDialog" v-if="addQuDialogVisible">
      <el-form label-width="100px">
        <el-form-item label="区域名称">
          <el-input v-model="AddArea.params.areaName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddQuDialog">取 消</el-button>
        <el-button type="primary" @click="addQu">确定添加</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  data() {
    return {
      addQuDialogVisible: false,
      // 获取区域列表
      GetAreaList:{
        "version": 1,
        "method": "area.GetAreaList",
        "params": null
        ,
        "token": "",
        "id": 0
      },
      // 添加区域
      AddArea:{
        "version": 1,
        "method": "area.AddArea",
        "params": {
          "areaName": "",
          "fatherAreaId":"0"
        },
        "token": "",
        "id": 0
      },
      // 区域列表
      areaList:{
        "version": 1,
        "result":{
          "areaList": [
            {
              "areaId": "",
              "label": "",
              "childList":[],
            },
          ]
        },
        "id": 0
      },
      defaultExpandAll:true,
      addAreaVisible:false,
      updateAreaVisible:false,
      chosenLabel:'',
      chosenAreaId:'',
      chosenUser:'',
      // 删除区域
      DeleteArea:{
        "version": 1,
        "method": "area.DeleteArea",
        "params": {
          "areaId": ""
        },
        "token": "",
        "id": 0
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 修改区域
      UpdateArea:{
        "version": 1,
        "method": "area.UpdateArea",
        "params": {
          "areaId": "",
          "newAreaName": "",
        },
        "token": "",
        "id": 0
      },
    };
  },
  methods: {
    openAddQuDialog(){
      this.addQuDialogVisible = true;
    },
    closeAddQuDialog(){
      this.addQuDialogVisible = false;
    },
    addQu(){
      this.AddArea.params.fatherAreaId = "0";
      this.AddArea.token = this.$store.state.token;
      console.log('添加区域请求');
      console.log(this.AddArea);
      this.$axios.post(this.$mainUrl, this.AddArea).then(res=>{
        console.log('添加区域请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'添加区域成功',
          })
          this.closeAddQuDialog();
          this.getAreaList();
        }else{
          this.$message({
            type:'error',
            message:"添加区域失败," + res.data.error.message
          })
        }
      })
    },
    handleNodeClick(data) {
      console.log(data);
      this.chosenLabel = data.label;
      this.chosenAreaId = data.areaId;
      if(data.hasOwnProperty('managerName')){
        this.chosenUser = data.managerName;
      }else{
        this.chosenUser = '暂无'
      }
    },
    addAreaDialogVisible(){
      this.addAreaVisible = true;
    },
    UpdateAreaDialogVisible(){
      this.updateAreaVisible = true;
    },
    deleteArea(){
      this.DeleteArea.token = this.$store.state.token;
      this.DeleteArea.params.areaId = this.chosenAreaId;
      console.log('删除区域请求');
      console.log(this.DeleteAlarmRule);
      this.$confirm('此操作将永久删除区域“' + this.chosenLabel + '”, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$mainUrl, this.DeleteArea).then(res=>{
          console.log('删除区域请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type:'success',
              message: '删除区域成功'
            })
            this.getAreaList();
          }else{
            this.$message({
              type:'error',
              message:'删除区域失败，' + res.data.error.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    closeAddArea(){
      this.addAreaVisible = false;
    },
    closeUpdateArea(){
      this.updateAreaVisible = false;
    },
    // 添加区域
    addArea(){
      this.AddArea.params.fatherAreaId = this.chosenAreaId;
      this.AddArea.token = this.$store.state.token;
      console.log('添加区域请求');
      console.log(this.AddArea);
      this.$axios.post(this.$mainUrl, this.AddArea).then(res=>{
        console.log('添加区域请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'添加区域成功',
          })
          this.closeAddArea();
          this.getAreaList();
        }else{
          this.$message({
            type:'error',
            message:"添加区域失败," + res.data.error.message
          })
        }
      })
    },
    updateArea(){
      this.UpdateArea.params.areaId = this.chosenAreaId;
      this.UpdateArea.token = this.$store.state.token;
      console.log('修改区域请求');
      console.log(this.UpdateArea);
      this.$axios.post(this.$mainUrl, this.UpdateArea).then(res=>{
        console.log('修改区域请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'修改区域成功',
          })
          this.closeUpdateArea();
          this.getAreaList();
        }else{
          this.$message({
            type:'error',
            message:"修改区域失败," + res.data.error.message
          })
        }
      })
    },
    // 获取区域列表
    getAreaList(){
      this.GetAreaList.token = this.$store.state.token;
      console.log('获取区域列表请求');
      console.log(this.GetAreaList);
      this.$axios.post(this.$mainUrl, this.GetAreaList).then(res=>{
        console.log('获取区域列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          let areaList = JSON.stringify(res.data);
          areaList  = areaList.replace(/childList/g, 'children');
          areaList  = areaList.replace(/areaName/g, 'label');
          areaList = JSON.parse(areaList);
          console.log('areaList');
          console.log(areaList);
          this.areaList = areaList;
        }else{
          this.$message({
            type: 'error',
            message: '获取区域列表失败，' + res.data.error.message
          })
        }
      })
    },
  },
  mounted(){
    this.getAreaList();
  }

};
</script>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: 99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
